const PAYMENT_API = "https://fetc.in/api/v1/payment";

import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const paymentApi = createApi({
  reducerPath: "paymentApi",
  tagTypes: ["Orders", "Refunds", "Enrollments"],
  baseQuery: fetchBaseQuery({
    baseUrl: PAYMENT_API,
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    // Initiate Payment
   createOrder: builder.mutation({
  query: ({ userId, amount, phone, courseId, courseName, name, email }) => ({
    url: "/initiate-payment",
    method: "POST",
    body: {
      userId,              
      amount: Number(amount),
      phone,
      courseId,
      courseName,
      name,
      email,
    },
  }),
  invalidatesTags: ["Orders"],
}),
    // Enroll in Course (Free or Paid after success)
    enrollCourse: builder.mutation({
      query: ({ courseId }) => ({
        url: "/enroll",
        method: "POST",
        body: { courseId },
      }),
      invalidatesTags: ["Enrollments", "Orders"],
    }),

    // Check single payment status
    checkPaymentStatus: builder.query({
      query: (transactionId) => `/status/${transactionId}`,
      providesTags: (result, error, transactionId) => [
        { type: "Orders", id: transactionId },
      ],
    }),

    // Get all transactions (admin)
    getOrders: builder.query({
      query: ({
        status,
        page = 1,
        limit = 20,
        startDate,
        endDate,
        search,
      } = {}) => {
        const params = new URLSearchParams();
        params.append("page", String(page));
        params.append("limit", String(limit));
        if (status) params.append("status", status);
        if (startDate) params.append("startDate", startDate);
        if (endDate) params.append("endDate", endDate);
        if (search) params.append("search", search);

        return `/transactions?${params.toString()}`;
      },
      providesTags: ["Orders"],
    }),

    // Get single transaction by ID
    getOrderById: builder.query({
      query: (transactionId) => `/transactions/${transactionId}`,
      providesTags: (result, error, transactionId) => [
        { type: "Orders", id: transactionId },
      ],
    }),

    // Initiate Refund
    initiateRefund: builder.mutation({
      query: ({ originalTransactionId, refundId, amount }) => ({
        url: "/refund",
        method: "POST",
        body: {
          originalTransactionId,
          refundId,
          amount: Number(amount),
        },
      }),
      invalidatesTags: ["Orders", "Refunds"],
    }),

    // Get Refund Status
    getRefundStatus: builder.query({
      query: (refundId) => `/refund/${refundId}`,
      providesTags: (result, error, refundId) => [
        { type: "Refunds", id: refundId },
      ],
    }),

    // Transaction Statistics
    getTransactionStats: builder.query({
      query: ({ startDate, endDate } = {}) => ({
        url: "/transactions/stats",
        params: { startDate, endDate },
      }),
      providesTags: ["Orders"],
    }),
    
    checkEnrollment: builder.query({
  query: (courseId) => `/enrollment-status/${courseId}`,
  providesTags: ["Enrollments"],
}),

getMyOrders: builder.query({
  query: (email) => {
    const params = new URLSearchParams();
    params.append("search", email);
    params.append("status", "SUCCESS");
    params.append("limit", "100");

    return `/transactions?${params.toString()}`;
  },
  providesTags: ["Orders"],
}),

    // Delete Transaction (Admin)
    deleteOrder: builder.mutation({
      query: (transactionId) => ({
        url: `/transactions/${transactionId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Orders"],
    }),
  }),
});

export const {
  useCreateOrderMutation,
  useEnrollCourseMutation,
  useCheckPaymentStatusQuery,
  useGetOrdersQuery,
  useGetMyOrdersQuery,
  useGetOrderByIdQuery,
  useInitiateRefundMutation,
  useGetRefundStatusQuery,
  useGetTransactionStatsQuery,
  useDeleteOrderMutation,
  useCheckEnrollmentQuery,
} = paymentApi;